import { render, staticRenderFns } from "./JColour.vue?vue&type=template&id=4645df62&scoped=true"
import script from "./JColour.vue?vue&type=script&lang=js"
export * from "./JColour.vue?vue&type=script&lang=js"
import style0 from "./JColour.vue?vue&type=style&index=0&id=4645df62&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4645df62",
  null
  
)

export default component.exports